/**
 * Results API Layer - Search
 * Initializes Tagalys SearchResults SDK for search template
 */

class ResultsAPISearch {
  constructor () {
    this.eventBus = window.theme.tagalys.results.eventBus
    this.query = new URLSearchParams(window.location.search).get('q') || ''

    onTagalysReady(() => {
      this.initializeTagalysSearchResults()
    })
  }

  /**
   * Extracts search parameters from URL for Tagalys API
   * @returns {Object} Object containing filters, sortOrder, and page
   */
  extractSearchParams () {
    const urlParams = new URLSearchParams(window.location.search)

    const filters = {}
    const filterParams = urlParams.getAll('filter')
    filterParams.forEach(filterParam => {
      const dashIndex = filterParam.indexOf('-')
      if (dashIndex !== -1) {
        const filterName = filterParam.substring(0, dashIndex)
        const values = filterParam.substring(dashIndex + 1).split(',')
        filters[filterName] = values
      }
    })

    const page = parseInt(urlParams.get('page'), 10) || 1
    const sortOrder = urlParams.get('sort') || ''

    return {
      filters,
      sortOrder,
      page
    }
  }

  initializeTagalysSearchResults () {
    const { filters, sortOrder, page } = this.extractSearchParams()

    window.theme.tagalys.results.SDK = Tagalys.APIConnector.SearchResults.new({
      params: {
        query: this.query,
        filters: {
          ...filters
        },
        sort: sortOrder,
        perPage: window.theme.resultsConfig.productsPerPage || 32,
        page: page || 1,
      },
      failover: this.initializeShopifySearchResults.bind(this),
      onSuccess: response => {
        this.eventBus.publish('results:api:fetched:success', response)
      },
      onFailure: response => {
        console.error('Search results fetch failed', response)
      }
    })

    window.theme.tagalys.results.SDK.helpers.call()
    this.eventBus.publish('results:api:initialized')
  }

  initializeShopifySearchResults() {
    return Tagalys.APIConnector.ShopifySearchResults.new({
      params: {
        query: this.query,
      },
      onSuccess: response => {
        this.eventBus.publish('results:api:fetched:success', response)
      },
      onFailure: response => {
        console.error('Search results fetch failed for both Tagalys and Shopify', response)
      }
    });
  }
}

window.theme.tagalys.results.apiLayer = new ResultsAPISearch()
